import React from "react";
import { Component } from "react";
//import Select from 'react-select';

export class CustomMultiSelect extends Component {
    constructor(props) {
        super(props);
        this.state={
            selectedOptions:[]
        }
    }
    render(){
        //const handleChange = (selected) => {
        //    this.setState({selectedOptions:selected})
        //  };
        return (
            null
            //<Select
            //    options={this.props.options}
            //    isMulti
            //    value={this.state.selectedOptions}
            //    onChange={handleChange}
            ///>
        )
    }
}